module.exports = __webpack_public_path__ + "img/Wrap_any_rest_API_with_GraphQL_from_the_frontend.a1c69dfd.jpeg";